export const messageTypes = {
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
}
